// extracted by mini-css-extract-plugin
module.exports =  {"tc-with-drawer":"withDrawer-module__tc-with-drawer___S3f7s","tc-with-drawer-container":"withDrawer-module__tc-with-drawer-container___lw3T_"};